// src/config.js
// Central API base URL. Local browser sessions use the local Express server;
// production sessions call the same domain that serves the deployed app.
const isDev = window.location.hostname === 'localhost';

export const API_URL = isDev
  ? 'http://localhost:5001/api'
  : 'https://markazsync.com/api';
